<template>
  <section>
    <div class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2">
      
      <div class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white z-20">
        <DropDownOptions 
          v-model="selectedFilter"
          :label="'Documentos'" 
          :options="[
            'Todos', 
            ...filters
          ]" 
        />

        <SearchInput v-model="searchTerm" />
      </div>

      <DataTable :data="filteredData" @delete="deleteDocument">
        <template #head>
          <th scope="col" class="px-6 py-3">Funcionário</th>
          <th scope="col" class="px-6 py-3">Tipo</th>
          <th scope="col" class="px-6 py-3">Observação</th>
          <th scope="col" class="px-6 py-3">Data do upload</th>
          <th scope="col" class="px-6 py-3">#</th>
        </template>
      </DataTable>

    </div>
  </section>
</template>

<script setup>
import DropDownOptions from "@/components/Tables/DropDownOptions.vue";
import SearchInput from "@/components/Tables/SearchInput.vue";
import DataTable from "@/components/Tables/DataTable.vue";
import AsosService from "../../service/asos.service";
import moment from "moment";
import { showToast as toast } from '@/helpers/UseToasts'
import { computed, onMounted } from "vue";
import { dataAso } from "./../../store";
import { initFlowbite } from "flowbite";
import { storeApp } from "@/store";
import { ref } from "vue";

const store = dataAso;
const searchTerm = ref("");
const selectedFilter = ref("");
let permissions = localStorage.getItem('__permissions')
let permissionArray = permissions?.split(',');
const uploadPermission = ref(
  permissionArray.includes('docs_upl') 
)

const dataTable = computed(() => {
  return store.getters?.getDocs
  .filter((row) => {
      if (! uploadPermission.value) {
        return row.user_id === localStorage.getItem('__uuid');
      }
      return true;
    })
  .map((row) => {
    const valueData = row.value ? JSON.parse(row.value) : {};

    return {
      ...row,
      ...valueData
    };
  });
})

const filters = [ ...new Set(dataTable.value?.map(i => i.key))]

// filtros
const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase();

  return dataTable.value.filter((row) => {
    if(selectedFilter.value === 'Todos') 
    selectedFilter.value = '';

    const matchesDropdown = !selectedFilter.value || row['key'] === selectedFilter.value;

    const matchesSearch = !searchTerm.value || 
      ['collab_name', 'collab_role', 'docOriginalName', 'expired_at', 'key'].some(
        (key) =>
          row[key] && row[key].toString().toLowerCase().includes(searchTermLower)
      );

    return matchesDropdown && matchesSearch;
  });
});

async function deleteDocument (doc, id) {
  storeApp.state.loading = true
  const confirm = window.confirm('Deseja realmente remover este documento?')
  if (confirm) {
    // apaga o doc do servidor
    Promise.allSettled([
      AsosService.removeDoc(doc).catch(err => {
        this.toast(
          'Aviso',
          'Documento ainda disponivel no servidor',
          'info'
        )
      })
    ])

    await AsosService.removeDocRegister(id)
      .then(res => {
        storeApp.state.loading = false

        if (res?.data?.success) {
          dataAso.dispatch('setAllDocs', res?.data?.data)
          
          return toast(
            'Sucesso',
            res?.data?.message,
            'success'
          )
        }
      }).catch(err => {
        storeApp.state.loading = false

        if (err?.response?.data?.error && err.response.data.status === 400) {
          return toast(
            'Aviso',
            err.response.data.message,
            'error'
          )
        }

        return toast(
          'Aviso',
          'Algo deu errado ao remover registrar',
          'error'
        )
      })
  }
  storeApp.state.loading = false
}

onMounted(() => {
  initFlowbite();
});
</script>
